import React, { useState, useEffect, useMemo, useRef } from "react";

// import axios from "axios";
import { fetchNplHourly, fetchNplOccupancy } from "../../../api/nplApi";
import LineChartComponent from "../LineChartComponent";
import SvgComponent from "../SvgComponent";
import useConfig from "../../../hooks/useConfig";
import GeneralMainMap from "../GeneralMainMap";
import YsbMainMap from "./NationalParkMainMap";
import "./index.css";
import ApexLineChart from "../ApexLineChartComponent";
import ApexMultiBarChart from "../ApexMultiBarChartComponent";
import CountUp from "react-countup";
import { Grid } from '@radix-ui/themes';
import GoogleAreaChart from "../GoogleAreaChart";
import { GoogleGaugeChart } from "../GoogleGaugeChart";
import { subDays, startOfToday, endOfDay } from "date-fns";
// import {
//     Card,
//     CardContent,
//     CardDescription,
//     CardFooter,
//     CardHeader,
//     CardTitle,
//   } from "@/components/ui/card"
import { ShadLineChart } from "../ShadChart";
// import { Component as BarChart } from "../ShadBarChart";
import { Component as MultiBarChart } from "../ShadMultiBar";
import { Component as RadialChart } from "../ShadRadialChart";
import { Component as DonutChart } from "../ShadDonutChart";
import { Skeleton } from "../../ui/Skeleton";
import { NationalParkBarChart } from "./NationalParkShadBarChart";
import { NationalParkShadLineChart } from "./NationalParkShadLineChart";
import { NationalParkOccupancyStrip } from "./NationalParkOccupancyStrip";
import { NationalParkDonutChart } from "./NationalParkDonutChart";
import { NationalParkHeatmapChart } from "./NationalParkHeatmapChart";
import { NationalParkSiteMap } from "./NationalParkSiteMap";
import { NationalParkKpiCards } from "./NationalParkKpiCards";
import { vacancyFromHourly } from "./nplOccupancyFromHourly";
import { computeNplKpis } from "./nplKpiFromHourly";
// import { DatePickerDemo } from "../DateRangePicker";
// import {Button} from "@shadcn/ui";
// import { Button } from "@/components/ui/button"
// import { cn } from "@/lib/utils"

// import InfoBox from "../../InfoBox";
// import GreenArrowUp from "../../../images/GreenArrowUp";
// import RedArrowDown from "../../../images/RedArrowDown";

var request_updateTimelineData_safe = true;

function getLocalHour(date) {
    if (date) {
        let hour = new Date(date).getHours();
        return hour < 10 ? `0${hour}:00` : `${hour}:00`;
    }
}
function findHourData(timeline, hour, device) {
    for (let i = 0; i < timeline.length; i++) {
        if (timeline[i]["hour"] === hour) {
            return { success: 1, timeline: timeline[i] };
        }
    }
    return { success: -1, hour, timeline: timeline[0], [device]: 0 };
}

// function margeSameHours(timeline) {
//   let temp = [];
//   for (let i = 0; i < timeline.length; i++) {
//     let currentChecker = timeline[i];
//     let deviceId = currentChecker["deviceId"];

//     for (let j = i + 1; j < timeline.length; j++) {
//       if (
//         parseInt(timeline[i]["hour"].split(":")[0]) ===
//           parseInt(timeline[j]["hour"].split(":")[0]) &&
//         currentChecker["deviceId"] === timeline[j]["deviceId"]
//       ) {
//         currentChecker[deviceId] =
//           currentChecker[deviceId] + timeline[j][deviceId];
//       }
//     }
//     temp.push(currentChecker);
//   }

//   return temp;
// }
function margeSameHours(timeline) {
    let hours = new Set();
    let data = [];
    for (let i = 0; i < timeline.length; i++) {
        if (i === 0) {
            hours.add(timeline[i]["hour"]);
            let currentChecker = timeline[i];
            for (let j = 1; j < timeline.length; j++) {
                if (currentChecker["hour"] === timeline[j]["hour"]) {
                    currentChecker["leaving"] += timeline[j]["leaving"];
                    currentChecker["entering"] += timeline[j]["entering"];
                    currentChecker["total"] += timeline[j]["total"];
                }
            }
            data.push(currentChecker);
        } else if (!hours.has(timeline[i]["hour"])) {
            hours.add(timeline[i]["hour"]);
            let currentChecker = timeline[i];
            for (let j = i + 1; j < timeline.length; j++) {
                if (currentChecker["hour"] === timeline[j]["hour"]) {
                    currentChecker["leaving"] += timeline[j]["leaving"];
                    currentChecker["entering"] += timeline[j]["entering"];
                    currentChecker["total"] += timeline[j]["total"];
                }
            }
            data.push(currentChecker);
        } else continue;
    }
    return data.sort(
        (a, b) =>
            new Date(
                new Date().getFullYear(),
                new Date().getMonth(),
                new Date().getDate(),
                parseInt(a["hour"].split(".")[0])
            ) -
            new Date(
                new Date().getFullYear(),
                new Date().getMonth(),
                new Date().getDate(),
                parseInt(a["hour"].split(".")[0])
            )
    );
}

function fillLine(timeline, devices) {
    let temp = [];
    // Minus 1 to hide current hour (if now it's 10:40, show in the chart only until 9:59)
    for (let j = 0; j < devices.length; j++) {
        const device = devices[j];
        for (let i = 0; i <= new Date().getHours(); i++) {
            let hour = i < 10 ? `0${i}:00` : `${i}:00`;
            let res = findHourData(timeline, hour, device);
            if (res.success !== -1) {
                temp.push(res.timeline);
            } else {
                let obj = {
                    hour: hour,
                    [device]: 0,
                    keys: res.timeline["keys"],
                };
                for (let l = 0; l < res.timeline["keys"].length; l++) {
                    const element = res.timeline["keys"][l];
                    obj[element] = 0;
                }
                temp.push(obj);
            }
        }
    }
    return temp;
}
// var request_updateTrackObjects_safe = true;

const NationalParkCombinedComponents = ({ token, areas, map }) => {
    // const [rest_trackObj, setRest_trackObj] = useState({});

    const [timelineData, setTimelineData] = useState([]);
    const [timelineDataTsinberi, setTimelineDataTsinberi] = useState([]);
    const [timelineDataShikmim, setTimelineDataShikmim] = useState([]);
    const [timelineDataKursi, setTimelineDataKursi] = useState([]);
    // const [timelineData, setTimelineData] = useState([]);
    const [DummytimelineData, setDummytimelineData] = useState([]);

    const [loadingChart, setLoadingChart] = useState(true);
    // const [deviceVelocity, setdeviceVelocity] = useState([]);
    const [deviceKeys, setDeviceKeys] = useState(() => {
        // let map = new Map();
        // Array.from(areas).forEach((area) => {
        //   Array.from(area.devices).forEach((device) => {
        //     map.set(device.deviceId, device.name);
        //   });
        // });
        // let devices = [...map.keys()].reverse();
        let devices = ["entering", "leaving"];
        return devices;
    });
    const [sum, setSum] = useState(0);
    const [tsinberiSum, setTsinberiSum] = useState(0);
    const [ShikmimSum, setShikmimSum] = useState(0);
    const [kursiSum, setKursiSum] = useState(0);
    const [compareSum, setCompareSum] = useState(0);
    const [compareSumTsinberi, setCompareSumTsinberi] = useState(0);
    const [compareSumShikmim, setCompareSumShikmim] = useState(0);
    const [compareSumKursi, setCompareSumKursi] = useState(0);
    const [totaloccupancy, settotaloccupancy] = useState(0);
    const [timeBasedData, setTimeBasedData] = useState("");
    const [dataDuration, setDataDuration] = useState("6M");
    const [vacancyValue, setVacancyValue] = useState([]);
    const [total, setTotal] = useState(0);
    const [dataTest, setDataTest] = new useState([]);
    const { config } = useConfig();
    const colors = ["#55b8ba", "#6363FF"];
    const svgColors = ["#55b8ba", "#6363FF"];
    const entryDevices = ["600a0c2a69e8a8fc", "600a0c2a69e8a8fe", "600a0c2a69e8a8f8", "600a0c2a69e8a902", "600a0c2a69e8a908"];
    const exitDevices = ["600a0c2a69e8a8fa", "600a0c2a69e89a80", "600a0c2a69e8829a", "600a0c2a69e8a900", "600a0c2a69e8a904"];
    const [dataByDuration, setDataByDuration] = useState([]);
    const [lineDataByDuration, setLineDataByDuration] = useState([]);
    const [hourlyByLocation, setHourlyByLocation] = useState({});
    const [donutDataByDuration, setDonutDataByDuration] = useState([]);
    const [loader, setLoader] = useState(false);
    const deviceMap = new Map;
    let DeviceNames = config.areas.map(el => {
        // let area = el.area.replace("_"," ")
        deviceMap.set(el.area, el.devices.map(d => d.deviceId));
        return el.area;
    });
    const [currentEntryDevices, setCurrentEntryDevices] = useState(() => deviceMap.get(DeviceNames[0]).filter(d => entryDevices.includes(d)));
    const [currentExitDevices, setCurrentExitDevices] = useState(() => deviceMap.get(DeviceNames[0]).filter(d => exitDevices.includes(d)));

    // console.log(currentEntryDevices,currentExitDevices,"testo");    
    const [deviceName, setDeviceName] = useState(DeviceNames[0]);
    const [lineDeviceName, setLineDeviceName] = useState(DeviceNames[0]);
    const [donutDeviceName, setDonutDeviceName] = useState(DeviceNames[0]);
    const colorTexts = [
        "text-cyan-700",
        "text-blue-700",
        "text-purple-400",
        "text-green-700",
    ];
    const [loadingBalance, setLoadingBalance] = useState(true);
    const textDescription = ["Entering", "Leaving"];
    const textChartDescription = ["Kineret 1 ", "Kineret 2 "];
    let stateData = [
        // timelineData
        timelineDataTsinberi,
        timelineDataShikmim,
        timelineDataKursi,
    ];
    let sumstateData = [compareSumTsinberi, compareSumShikmim, compareSumKursi];
    // console.log(config.areas, "config.areas");
    // console.log(compareSum, "compareSum--");
    // console.log(tsinberiSum, ShikmimSum, "show sum");
    let dummyOtherDeviceData = [
        {
            date: "2023-09-25T21:00:31.587Z",
            day: 25,
            deviceId: "600a0c2a69e8a8fa",
            hour: "21:00",
            id: 5710156495010099,
            micromobilityCount: 0,
            month: 9,
            order: 21,
            otherCount: 0,
            peopleCount: 0,
            timestamp: 1695675600000,
            totalCount: 7,
            vehiclesCount: 7,
            year: 2023,
            _id: "6511f4f461ae4b00b1cb9316",
        },

        {
            date: "2023-09-25T22:51:24.709Z",
            day: 25,
            deviceId: "600a0c2a69e8a8fa",
            hour: "22:00",
            id: 5710156495010099,
            micromobilityCount: 0,
            month: 9,
            order: 22,
            otherCount: 0,
            peopleCount: 0,
            timestamp: 1695679200000,
            totalCount: 1,
            vehiclesCount: 1,
            year: 2023,
            _id: "65120eec61ae4b00b1cb9318",
        },

        {
            date: "2023-09-25T23:14:09.973Z",
            day: 25,
            deviceId: "600a0c2a69e8a8fa",
            hour: "23:00",
            id: 5710156495010099,
            micromobilityCount: 0,
            month: 9,
            order: 23,
            otherCount: 0,
            peopleCount: 0,
            timestamp: 1695682800000,
            totalCount: 1,
            vehiclesCount: 1,
            year: 2023,
            _id: "6512144261ae4b00b1cb931a",
        },

        {
            date: "2023-09-26T00:19:19.682Z",
            day: 26,
            deviceId: "600a0c2a69e8a8fa",
            hour: "0:00",
            id: 5710156495010099,
            micromobilityCount: 0,
            month: 9,
            order: 0,
            otherCount: 0,
            peopleCount: 0,
            timestamp: 1695686400000,
            totalCount: 4,
            vehiclesCount: 4,
            year: 2023,
            _id: "6512238761ae4b00b1cb931c",
        },

        {
            date: "2023-09-26T03:39:48.952Z",
            day: 26,
            deviceId: "600a0c2a69e8a8fc",
            hour: "3:00",
            id: 5710156495010099,
            micromobilityCount: 0,
            month: 9,
            order: 3,
            otherCount: 0,
            peopleCount: 0,
            timestamp: 1695697200000,
            totalCount: 4,
            vehiclesCount: 4,
            year: 2023,
            _id: "6512528b61ae4b00b1cb931e",
        },

        {
            date: "2023-09-26T04:02:15.359Z",
            day: 26,
            deviceId: "600a0c2a69e8a8fc",
            hour: "4:00",
            id: 5710156495010099,
            micromobilityCount: 0,
            month: 9,
            order: 4,
            otherCount: 0,
            peopleCount: 0,
            timestamp: 1695700800000,
            totalCount: 5,
            vehiclesCount: 5,
            year: 2023,
            _id: "651258f061ae4b00b1cb9324",
        },

        {
            date: "2023-09-26T05:44:44.307Z",
            day: 26,
            deviceId: "600a0c2a69e8a8fc",
            hour: "5:00",
            id: 5710156495010099,
            micromobilityCount: 0,
            month: 9,
            order: 5,
            otherCount: 0,
            peopleCount: 0,
            timestamp: 1695704400000,
            totalCount: 2,
            vehiclesCount: 2,
            year: 2023,
            _id: "65126fd461ae4b00b1cb932a",
        },
        {
            date: "2023-09-26T06:00:32.428Z",
            day: 26,
            deviceId: "600a0c2a69e8a8fc",
            hour: "6:00",
            id: 5710156495010099,
            micromobilityCount: 0,
            month: 9,
            order: 6,
            otherCount: 0,
            peopleCount: 0,
            timestamp: 1695708000000,
            totalCount: 12,
            vehiclesCount: 12,
            year: 2023,
            _id: "6512738b61ae4b00b1cb932c",
        },
    ];
    // console.log(dummyOtherDeviceData.length, "show the dummyOtherDeviceData");
    function getDeviceNames() {
        let map = new Map();

        Array.from(areas).forEach((area) => {
            Array.from(area.devices).forEach((device) => {
                map.set(device.deviceId, device.name);
            });
        });
        let devices = ["entering", "leaving"];

        setDeviceKeys((prev) => devices);
        // setDeviceKeys((prev) => [...map.keys()]);
    }

    // function testDataTimeLine() {
    //   let data = [];
    //   let hour = new Date().getHours();

    //   for (let index = 0; index < deviceKeys.length; index++) {
    //     const device = deviceKeys[index];
    //     for (let index = hour; index > 0; index--) {
    //       let date = new Date();
    //       date.setHours(index);
    //       let id = device.slice(10);
    //       let keys = [`entering-${id}`, `leaving-${id}`];
    //       let obj = {
    //         deviceId: device,
    //         hour: getLocalHour(date),
    //         keys: keys,
    //         [device]: Math.floor(Math.random() * 500),
    //       };
    //       data.push(obj);
    //     }
    //   }
    //   // data = margeSameHours(data);
    //   // data = fillLine(data);
    //   // setTimelineData((prev) => data);
    //   setTimelineData((prev) => data);
    //   setLoadingChart(false);
    // }
    // console.log(deviceKeys, "show deviceKeys");
    function updateTimeBasedData(date) {
        // console.log(loader,"oneLoader");
        // setTimeout(()=>{
        //     console.log("timOut");            
        // },9000)
        console.log(date, "show t2he date");
        
        // if (!date) {
        //     const today = startOfToday();
        //     date = {
        //         from: today,
        //         to: subDays(today, 27), // Default to a week from today
        //     };
        // }
        date.to = endOfDay(date.to);
        console.log(date, "show t2he date");
        
        fetchNplHourly({ dateRangeFrom: date.from, dateRangeTo: date.to, locations: DeviceNames })
            .then(res => {
                if (res.data.multi) {
                    const multiResults = res.data.results;
                    setDataByDuration(DeviceNames.map(name => ({ result: multiResults[name] || [] })));
                } else {
                    console.error("Expected multi-location response from API");
                }
            })
            .catch(err => console.error(err));
    }

    function updateTimeBasedDonutData() {
        fetchNplHourly({ dataDuration: "21D", location: donutDeviceName }).then(res => {setDonutDataByDuration(res.data.result);setLoadingChart(false)}).catch(err => console.error(err))
    }

    /**
     * npl_hourly_stats via text/test:
     *  - 21D history first so occupancy isn't painted from an empty/short window
     *  - 1D live poll (~10s) merges into that series so today stays current
     */
    const lotNamesRef = useRef(DeviceNames);
    const lineLotRef = useRef(lineDeviceName);
    const hourlyRef = useRef(hourlyByLocation);
    const hourlyLiveSeq = useRef(0);
    const hourlyHistSeq = useRef(0);
    const historyReadyRef = useRef(false);
    const pendingLiveRef = useRef(null);
    lotNamesRef.current = DeviceNames;
    lineLotRef.current = lineDeviceName;
    hourlyRef.current = hourlyByLocation;

    function parseMultiHourly(res, fallbackLot) {
        const multi = res.data?.multi
            ? res.data.results || {}
            : { [fallbackLot]: res.data?.result || [] };
        const byLoc = {};
        lotNamesRef.current.forEach((name) => {
            byLoc[name] = Array.isArray(multi[name]) ? multi[name] : [];
        });
        return byLoc;
    }

    function applyHourlyToUi(byLoc) {
        hourlyRef.current = byLoc;
        setHourlyByLocation(byLoc);
        setLineDataByDuration(byLoc[lineLotRef.current] || []);
    }

    function mergeRecentHours(prevByLoc, recentByLoc) {
        const next = { ...prevByLoc };
        lotNamesRef.current.forEach((lot) => {
            const recent = recentByLoc[lot] || [];
            const prev = prevByLoc[lot] || [];
            if (!recent.length) {
                next[lot] = prev;
                return;
            }
            const cutoff = Math.min(...recent.map((r) => new Date(r.date).getTime()));
            const kept = prev.filter((r) => new Date(r.date).getTime() < cutoff);
            next[lot] = [...kept, ...recent].sort(
                (a, b) => new Date(a.date) - new Date(b.date)
            );
        });
        return next;
    }

    function refreshHourlyHistory() {
        const seq = ++hourlyHistSeq.current;
        fetchNplHourly({ dataDuration: "21D", locations: lotNamesRef.current })
            .then((res) => {
                if (seq !== hourlyHistSeq.current) return;
                const history = parseMultiHourly(res, lineLotRef.current);
                historyReadyRef.current = true;
                const pending = pendingLiveRef.current;
                pendingLiveRef.current = null;
                applyHourlyToUi(
                    pending ? mergeRecentHours(history, pending) : history
                );
            })
            .catch((err) => console.error(err));
    }

    function refreshHourlyLive() {
        const seq = ++hourlyLiveSeq.current;
        fetchNplHourly({ dataDuration: "1D", locations: lotNamesRef.current })
            .then((res) => {
                if (seq !== hourlyLiveSeq.current) return;
                const recent = parseMultiHourly(res, lineLotRef.current);
                if (!historyReadyRef.current) {
                    pendingLiveRef.current = recent;
                    return;
                }
                const prev = hourlyRef.current || {};
                applyHourlyToUi(mergeRecentHours(prev, recent));
            })
            .catch((err) => console.error(err));
    }

    function refreshOccupancy() {
        fetchNplOccupancy()
            .then((res) => {
                const lots = res.data?.lots || [];
                const byZone = {};
                lots.forEach((lot) => {
                    if (lot?.zoneId) byZone[lot.zoneId] = lot;
                });
                setVacancyValue(
                    lotNamesRef.current.map((name) => {
                        const lot = byZone[name];
                        if (lot && Number.isFinite(Number(lot.vacancy))) {
                            return Number(lot.vacancy) < 1 ? "אלמ" : Number(lot.vacancy);
                        }
                        return vacancyFromHourly(hourlyRef.current[name] || [], name);
                    })
                );
            })
            .catch((err) => console.error(err));
    }

    // function updateTimelineData() {
    //     if (request_updateTimelineData_safe === false) {
    //         return;
    //     } else {
    //         request_updateTimelineData_safe = false;
    //     }
    //     axios
    //         .get(
    //             `/v1/statistics/hour?token=${token}&day=${new Date().getUTCDate()}&month=${new Date().getUTCMonth() + 1
    //             }&areas=${null}`
    //         )
    //         .then((res) => {
    //             //kursi beach data
    //             let resData = [];
    //             let leaving = 0;
    //             let entering = 0;
    //             let fakeData = [];
    //             //tsinberi Data
    //             let tsinberiData = [];
    //             let leavingTsinberi = 0;
    //             let enteringTsinberi = 0;
    //             //shikmim data
    //             let shikmimData = [];
    //             let leavingshikmim = 0;
    //             let enteringshikmim = 0;
    //             //Kursi beach original Data
    //             let kursiData = [];
    //             let leavingKursi = 0;
    //             let enteringKursi = 0;
    //             // let dummyresData = [];
    //             let data = res.data.flat();
    //             // console.log(data,"faltData");                
    //             //         const result = {};
    //             // const encounteredHours = new Set();

    //             // for (const item of data) {
    //             //   const { hour, deviceId } = item;
    //             //   const hourDeviceKey = `${hour}-${deviceId}`;

    //             //   if (!encounteredHours.has(hour)) {
    //             //     result[hour] = {};
    //             //     result[hour][deviceId] = item;
    //             //     encounteredHours.add(hour);
    //             //   } else if (!result[hour][deviceId]) {
    //             //     result[hour][deviceId] = item;
    //             //   }
    //             // }

    //             // const finalResult = Object.values(result).flatMap((hourData) =>
    //             //   Object.values(hourData)
    //             // );
    //             const result = {};
    //             const encounteredCombinations = new Set();

    //             for (const item of data) {
    //                 const { hour, deviceId } = item;
    //                 const combinationKey = `${hour}-${deviceId}`;

    //                 if (!encounteredCombinations.has(combinationKey)) {
    //                     if (!result[hour]) {
    //                         result[hour] = {};
    //                     }
    //                     if (!result[hour][deviceId]) {
    //                         result[hour][deviceId] = [];
    //                     }
    //                     if (result[hour][deviceId].length < 4) {
    //                         result[hour][deviceId].push(item);
    //                         encounteredCombinations.add(combinationKey);
    //                     }
    //                 }
    //             }

    //             const finalResult = Object.values(result).flatMap((hourData) =>
    //                 Object.values(hourData).flatMap((deviceData) => deviceData)
    //             );

    //             // console.log(finalResult,"finalRes");

    //             // console.log(finalResult,"show final resultttt");
    //             // console.log(data.length, "show the response data length");
    //             // console.log(data, "show the response data ");
    //             let devicCHeck = data.filter((d, k) => {
    //                 return d.deviceId === "600a0c2a69e8508a" ||
    //                     d.deviceId === "600a0c2a69e85084"
    //                     ? d.deviceId
    //                     : null;
    //             });
    //             // console.log(devicCHeck, "devicCHeck");

    //             //kursi data
    //             // for (let j = 0; j < data.length; j++) {
    //             //   // console.log(parseInt(res.data[i][j]["hour"].split(":")[0]));
    //             //   let deviceId = data[j]["deviceId"];
    //             //   let hour = new Date(data[j]["date"]).getHours();
    //             //   console.log(deviceId, hour, "deviceId,hour");
    //             //   // Minus 1 to hide current hour (if now it's 10:40, show in the chart only until 9:59)
    //             //   if (hour <= new Date().getHours()) {
    //             //     console.log(hour, "less hour");
    //             //     console.log(deviceId.slice(10), "deviceId.slice(10)");
    //             //     let id = deviceId.slice(10);
    //             //     let keys = [`entering-${id}`, `leaving-${id}`];
    //             //     let obj = {
    //             //       deviceId: deviceId,
    //             //       hour: getLocalHour(data[j]["date"]),
    //             //       keys: keys,
    //             //       leaving:
    //             //         deviceId === "600a0c2a69e812dc" ||
    //             //         deviceId === "600a0c2a69e816d8"
    //             //           ? data[j]["vehiclesCount"] + data[j]["otherCount"]
    //             //           : 0,
    //             //       entering:
    //             //         deviceId === "600a0c2a69e811c8" ||
    //             //         deviceId === "600a0c2a69e816da"
    //             //           ? data[j]["vehiclesCount"] + data[j]["otherCount"]
    //             //           : 0,
    //             //       total: data[j]["vehiclesCount"] + data[j]["otherCount"],
    //             //     };
    //             //     if (
    //             //       deviceId === "600a0c2a69e811c8" ||
    //             //       deviceId === "600a0c2a69e816da"
    //             //     ) {
    //             //       entering += data[j]["vehiclesCount"] + data[j]["otherCount"];
    //             //     } else {
    //             //       leaving += data[j]["vehiclesCount"] + data[j]["otherCount"];
    //             //     }
    //             //     resData.push(obj);
    //             //   }
    //             // }
    //             //tsinberi data
    //             // for (let j = 0; j < finalResult.length; j++) {
    //             //     // console.log(parseInt(res.data[i][j]["hour"].split(":")[0]));
    //             //     let deviceId = finalResult[j]["deviceId"];
    //             //     // console.log(deviceMap.get(deviceName).includes(deviceId),deviceName,deviceId,"devNam");                    
    //             //     if (deviceId === "600a0c2a69e8a8fa") {
    //             //         fakeData.push(finalResult[j]["vehiclesCount"]);
    //             //     }
    //             //     // console.log(fakeData,"show the Fake Data")
    //             //     let hour = new Date(finalResult[j]["date"]).getHours();
    //             //     // console.log(deviceId, hour, "deviceId,hour");
    //             //     // Minus 1 to hide current hour (if now it's 10:40, show in the chart only until 9:59)
    //             //     // const currentDay = new Date().getDate();
    //             //     // if (finalResult[j]["day"] === currentDay) {


    //             //     if (hour <= new Date().getHours()) {
    //             //         // console.log(hour, "less hour");
    //             //         // console.log(deviceId.slice(10), "deviceId.slice(10)");
    //             //         let id = deviceId.slice(10);
    //             //         let keys = [
    //             //             `entering-${entryDevices.includes(id) ? id : null}`,
    //             //             `leaving-${exitDevices.includes(id) ? id : null}`,
    //             //         ];
    //             //         let obj = {
    //             //             deviceId:
    //             //             deviceMap.get(deviceName).includes(deviceId)
    //             //                     ? deviceId
    //             //                     : null,
    //             //             hour: getLocalHour(finalResult[j]["date"]),
    //             //             keys: keys,
    //             //             leaving:
    //             //             exitDevices.includes(deviceId)
    //             //                     ? finalResult[j]["outCount"]
    //             //                     : // + data[j]["otherCount"]
    //             //                       0,
    //             //             entering:
    //             //             entryDevices.includes(deviceId)
    //             //                     ? finalResult[j]["inCount"]
    //             //                     : // + data[j]["otherCount"]
    //             //                       0,
    //             //             total:
    //             //                 finalResult[j]["vehiclesCount"] +
    //             //                 finalResult[j]["otherCount"],
    //             //         };
    //             //         if (entryDevices.includes(deviceId)) {
    //             //             enteringTsinberi += finalResult[j]["inCount"];
    //             //             // + data[j]["otherCount"];
    //             //         } else if (exitDevices.includes(deviceId)) {
    //             //             leavingTsinberi += finalResult[j]["outCount"];
    //             //             // + data[j]["otherCount"];
    //             //         }
    //             //         // if (obj.deviceId) {

    //             //             tsinberiData.push(obj);
    //             //         // }
    //             //     }
    //             // // }
    //             // }
    //             for (let j = 0; j < finalResult.length; j++) {
    //                 // console.log(parseInt(res.data[i][j]["hour"].split(":")[0]));
    //                 let deviceId = finalResult[j]["deviceId"];
    //                 if (deviceId === "600a0c2a69e8a8fa") {
    //                     fakeData.push(finalResult[j]["vehiclesCount"]);
    //                 }
    //                 // console.log(fakeData,"show the Fake Data")
    //                 let hour = new Date(finalResult[j]["date"]).getHours();
    //                 // console.log(deviceId, hour, "deviceId,hour");
    //                 // Minus 1 to hide current hour (if now it's 10:40, show in the chart only until 9:59)
    //                 // const currentDay = new Date().getDate();
    //                 // if (finalResult[j]["day"] === currentDay) {


    //                 if (hour <= new Date().getHours()) {
    //                     // console.log(hour, "less hour");
    //                     // console.log(deviceId.slice(10), "deviceId.slice(10)");
    //                     let id = deviceId.slice(10);
    //                     let keys = [
    //                         `entering-${currentEntryDevices.includes(id) ? id : null}`,
    //                         `leaving-${currentExitDevices.includes(id) ? id : null}`,
    //                     ];
    //                     let obj = {
    //                         deviceId:
    //                             deviceMap.get(deviceName).includes(deviceId)
    //                                 ? deviceId
    //                                 : null,
    //                         hour: getLocalHour(finalResult[j]["date"]),
    //                         keys: keys,
    //                         leaving:
    //                             currentExitDevices.includes(deviceId)
    //                                 ? finalResult[j]["outCount"]
    //                                 : // + data[j]["otherCount"]
    //                                 0,
    //                         entering:
    //                             currentEntryDevices.includes(deviceId)
    //                                 ? finalResult[j]["inCount"]
    //                                 : // + data[j]["otherCount"]
    //                                 0,
    //                         total:
    //                             finalResult[j]["vehiclesCount"] +
    //                             finalResult[j]["otherCount"],
    //                     };
    //                     if (deviceId === "600a0c2a69e8a8fc") {
    //                         enteringTsinberi += finalResult[j]["inCount"];
    //                         // + data[j]["otherCount"];
    //                     } else if (deviceId === "600a0c2a69e8a8fa") {
    //                         leavingTsinberi += finalResult[j]["outCount"];
    //                         // + data[j]["otherCount"];
    //                     }
    //                     // if (obj.deviceId) {

    //                     tsinberiData.push(obj);
    //                     // }
    //                 }
    //                 // }
    //             }

    //             //shikmim data
    //             for (let k = 0; k < finalResult.length; k++) {
    //                 // console.log(parseInt(res.data[i][j]["hour"].split(":")[0]));
    //                 let deviceId = finalResult[k]["deviceId"];
    //                 if (
    //                     deviceId === "600a0c2a69e85084" ||
    //                     deviceId === "600a0c2a69e8508a"
    //                 ) {
    //                     // console.log(deviceId, "show checked deviceId");
    //                 }
    //                 // console.log(deviceId, "show all deviceod888");
    //                 let hour = new Date(finalResult[k]["date"]).getHours();
    //                 // console.log(deviceId, hour, "deviceId,hour");
    //                 // Minus 1 to hide current hour (if now it's 10:40, show in the chart only until 9:59)
    //                 // const currentDay = new Date().getDate();
    //                 // if (finalResult[k]["day"] === currentDay) {
    //                 if (hour <= new Date().getHours()) {
    //                     // console.log(hour, "less hour");
    //                     // console.log(deviceId.slice(10), "deviceId.slice(10)");
    //                     let id = deviceId.slice(10);
    //                     let keys = [
    //                         `entering-${id === "600a0c2a69e85084" ? id : null}`,
    //                         `leaving-${id === "600a0c2a69e8508a" ? id : null}`,
    //                     ];
    //                     let obj = {
    //                         deviceId:
    //                             deviceId === "600a0c2a69e85084" ||
    //                                 deviceId === "600a0c2a69e8508a"
    //                                 ? deviceId
    //                                 : null,
    //                         hour: getLocalHour(finalResult[k]["date"]),
    //                         keys: keys,
    //                         leaving:
    //                             deviceId === "600a0c2a69e8508a"
    //                                 ? finalResult[k]["outCount"]
    //                                 : // + data[k]["otherCount"]
    //                                 0,
    //                         entering:
    //                             deviceId === "600a0c2a69e85084"
    //                                 ? finalResult[k]["inCount"]
    //                                 : //  + data[k]["otherCount"]
    //                                 0,
    //                         total:
    //                             finalResult[k]["vehiclesCount"] +
    //                             finalResult[k]["otherCount"],
    //                     };
    //                     if (deviceId === "600a0c2a69e85084") {
    //                         // console.log(deviceId,"show the de----===")
    //                         enteringshikmim += finalResult[k]["inCount"];
    //                         // + data[k]["otherCount"];
    //                     } else if (deviceId === "600a0c2a69e8508a") {
    //                         leavingshikmim += finalResult[k]["outCount"];
    //                         // + data[k]["otherCount"];
    //                     }
    //                     // if (obj.deviceId) {
    //                     shikmimData.push(obj);
    //                     // }
    //                 }
    //                 // }
    //             }

    //             //kursi data
    //             for (let l = 0; l < finalResult.length; l++) {
    //                 // console.log(parseInt(res.data[i][j]["hour"].split(":")[0]));
    //                 let deviceId = finalResult[l]["deviceId"];
    //                 if (
    //                     deviceId === "600a0c2a69e812dc" ||
    //                     deviceId === "600a0c2a69e808f0"
    //                 ) {
    //                     fakeData.push(finalResult[l]["vehiclesCount"]);
    //                 }
    //                 // console.log(fakeData,"show the Fake Data")
    //                 let hour = new Date(finalResult[l]["date"]).getHours();
    //                 // console.log(deviceId, hour, "deviceId,hour");
    //                 // Minus 1 to hide current hour (if now it's 10:40, show in the chart only until 9:59)
    //                 // const currentDay = new Date().getDate();
    //                 // if (finalResult[l]["day"] === currentDay) {
    //                 if (hour <= new Date().getHours()) {
    //                     // console.log(hour, "less hour");
    //                     // console.log(deviceId.slice(10), "deviceId.slice(10)");
    //                     let id = deviceId.slice(10);
    //                     let keys = [
    //                         `entering-${id === "600a0c2a69e816da" ||
    //                             id === "600a0c2a69e811c8"
    //                             ? id
    //                             : null
    //                         }`,
    //                         `leaving-${id === "600a0c2a69e812dc" ||
    //                             id === "600a0c2a69e808f0"
    //                             ? id
    //                             : null
    //                         }`,
    //                     ];
    //                     let obj = {
    //                         deviceId:
    //                             deviceId === "600a0c2a69e816da" ||
    //                                 deviceId === "600a0c2a69e812dc" ||
    //                                 deviceId === "600a0c2a69e811c8" ||
    //                                 deviceId === "600a0c2a69e808f0"
    //                                 ? deviceId
    //                                 : null,
    //                         hour: getLocalHour(finalResult[l]["date"]),
    //                         keys: keys,
    //                         leaving:
    //                             deviceId === "600a0c2a69e812dc" ||
    //                                 deviceId === "600a0c2a69e808f0"
    //                                 ? finalResult[l]["vehiclesCount"]
    //                                 : // + data[j]["otherCount"]
    //                                 0,
    //                         entering:
    //                             deviceId === "600a0c2a69e816da" ||
    //                                 deviceId === "600a0c2a69e811c8"
    //                                 ? finalResult[l]["vehiclesCount"]
    //                                 : // + data[j]["otherCount"]
    //                                 0,
    //                         total:
    //                             finalResult[l]["vehiclesCount"] +
    //                             finalResult[l]["otherCount"],
    //                     };
    //                     if (
    //                         deviceId === "600a0c2a69e816da" ||
    //                         deviceId === "600a0c2a69e811c8"
    //                     ) {
    //                         enteringKursi += finalResult[l]["vehiclesCount"];
    //                         // + data[j]["otherCount"];
    //                     } else if (
    //                         deviceId === "600a0c2a69e812dc" ||
    //                         deviceId === "600a0c2a69e808f0"
    //                     ) {
    //                         leavingKursi += finalResult[l]["vehiclesCount"];
    //                         // + data[j]["otherCount"];
    //                     }
    //                     // if (obj.deviceId) {
    //                     kursiData.push(obj);
    //                     // }
    //                 }
    //                 // }
    //             }
    //             // console.log(shikmimData, "show the shimimmmmmmmmmmmmmmm");
    //             // console.log(tsinberiData, "show the tsinberiiiiiiiiiiiiiii");
    //             // console.log(kursiData,"show the kursiiiiiiiiiiiii");

    //             // console.log(entering, leaving, "entering,leaving,");
    //             let enterLeaving = entering - leaving;
    //             // console.log(enterLeaving, "enterLeaving");
    //             let dailySum = entering - leaving + sum;
    //             let TotalTsinberi = enteringTsinberi - leavingTsinberi;
    //             let totalShikmim = enteringshikmim - leavingshikmim;
    //             // console.log(
    //             //   TotalTsinberi / 13,
    //             //   totalShikmim / 13,
    //             //   "TotalTsinberi,totalShikmim========="
    //             // );
    //             // let tsinberidailySum = Math.round(TotalTsinberi / 13) + tsinberiSum;
    //             // let shikmimdailySum = Math.round(totalShikmim / 13) + ShikmimSum;
    //             //old occupancy calculation of Tsinberi and Shikmim
    //             // let tsinberidailySum = Math.round(TotalTsinberi / 13) + tsinberiSum;
    //             // let shikmimdailySum = Math.round(totalShikmim / 13) + ShikmimSum;
    //             // console.log(tsinberiSum,ShikmimSum,"jjjjjjjjjjj")

    //             // console.log(shikmimdailySum, "shikmimdailySum0090909");
    //             // console.log(tsinberidailySum, "tsinberidailySumtsinberidailySum");
    //             resData = margeSameHours(resData);
    //             tsinberiData = margeSameHours(tsinberiData);
    //             shikmimData = margeSameHours(shikmimData);
    //             kursiData = margeSameHours(kursiData);

    //             let tsinberiDataFinal = tsinberiData.map((d, k) => {
    //                 return {
    //                     ...d,
    //                     leaving: Math.round(d.leaving),
    //                     entering: Math.round(d.entering),
    //                 };
    //             });
    //             let shikmimDataFinal = shikmimData.map((d, k) => {
    //                 return {
    //                     ...d,
    //                     leaving: Math.round(d.leaving),
    //                     entering: Math.round(d.entering),
    //                 };
    //             });
    //             let kursiDataFinal = kursiData.map((d, k) => {
    //                 return {
    //                     ...d,
    //                     leaving: Math.round(d.leaving),
    //                     entering: Math.round(d.entering),
    //                 };
    //             });
    //             //new occupnacy calculation for Tsinberi and Shikmim
    //             let tsinberiCurrentCalculate = tsinberiDataFinal.reduce(
    //                 (a, b) => {
    //                     return (a += b.entering - b.leaving);
    //                 },
    //                 0
    //             );
    //             let shikmimCurrentCalculate = shikmimDataFinal.reduce(
    //                 (a, b) => {
    //                     return (a += b.entering - b.leaving);
    //                 },
    //                 0
    //             );
    //             let kursiCurrentCalculate = kursiDataFinal.reduce((a, b) => {
    //                 return (a += b.entering - b.leaving);
    //             }, 0);
    //             // console.log(shikmimCurrentCalculate,"shikmimCurrentCalculate")
    //             // console.log(tsinberiCurrentCalculate,"tsinberiCurrentCalculate")
    //             let tsinberidailySum = tsinberiCurrentCalculate + tsinberiSum;
    //             let shikmimdailySum = shikmimCurrentCalculate + ShikmimSum;
    //             let kursidailySum = kursiCurrentCalculate + kursiSum;
    //             // console.log(tsinberidailySum,shikmimdailySum,"showwwwww_bothh")
    //             //new occupancy calculation ends here
    //             // console.log(tsinberiDataFinal, "tsinberiDataFinal");
    //             //   console.log(tsinberiData,"0000000000000")
    //             //   console.log(resData, "show the resData");
    //             let totalOccupancy = resData.reduce((a, b) => {
    //                 return a + b.entering;
    //             }, 0);
    //             settotaloccupancy(totalOccupancy + sum);
    //             // console.log(totaloccupancy, "totalOccupancy");
    //             // resData = fillLine(resData, devices);
    //             // if (dailySum < 0) {
    //             //   dailySum = 5;
    //             // }
    //             // if (tsinberidailySum < 0) {
    //             //     tsinberidailySum = 5;
    //             // }
    //             // if (shikmimdailySum < 0) {
    //             //     shikmimdailySum = 5;
    //             // }
    //             // if (kursidailySum < 0) {
    //             //     kursidailySum = 5;
    //             // }
    //             setCompareSum((prev) => dailySum);
    //             setCompareSumTsinberi((prev) => tsinberidailySum);
    //             setCompareSumShikmim((prev) => shikmimdailySum);
    //             setCompareSumKursi((prev) => kursidailySum);
    //             setTimelineData((prev) => resData);
    //             setTimelineDataTsinberi((prev) => tsinberiDataFinal);
    //             setTimelineDataShikmim((prev) => shikmimDataFinal);
    //             setTimelineDataKursi((prev) => kursiDataFinal);
    //             setLoadingChart(false);
    //             request_updateTimelineData_safe = true;
    //             // for(let k=0;k<dummyOtherDeviceData.length;k++){
    //             //   let deviceId = dummyOtherDeviceData[k]["deviceId"];
    //             //   console.log(deviceId,"show the deviceId-=-=-=-")
    //             //   let hour = new Date(dummyOtherDeviceData[k]["date"]).getHours();
    //             //   console.log(deviceId,hour,"deviceId,hour")
    //             //   // Minus 1 to hide current hour (if now it's 10:40, show in the chart only until 9:59)
    //             //   if (hour <= new Date().getHours()) {
    //             //     console.log(hour,"less hour")
    //             //     console.log(deviceId.slice(10),"deviceId.slice(10)")
    //             //     let id = deviceId.slice(10);
    //             //     let keys = [`entering-${id}`, `leaving-${id}`];
    //             //     let obj = {
    //             //       deviceId: deviceId,
    //             //       hour: getLocalHour(dummyOtherDeviceData[k]["date"]),
    //             //       keys: keys,
    //             //       leaving:
    //             //         deviceId === "600a0c2a69e8a8fa"
    //             //           ? dummyOtherDeviceData[k]["vehiclesCount"] + dummyOtherDeviceData[k]["otherCount"]
    //             //           : 0,
    //             //       entering:
    //             //         deviceId === "600a0c2a69e8a8fc"
    //             //           ? dummyOtherDeviceData[k]["vehiclesCount"] + dummyOtherDeviceData[k]["otherCount"]
    //             //           : 0,
    //             //       total: dummyOtherDeviceData[k]["vehiclesCount"] + dummyOtherDeviceData[k]["otherCount"],
    //             //     };
    //             //     console.log(obj,"show obj-----")
    //             //     // if (
    //             //     //   deviceId === "600a0c2a69e811c8" ||
    //             //     //   deviceId === "600a0c2a69e816da"
    //             //     // ) {
    //             //     //   entering += data[k]["vehiclesCount"] + data[k]["otherCount"];
    //             //     // } else {
    //             //     //   leaving += data[k]["vehiclesCount"] + data[k]["otherCount"];
    //             //     // }
    //             //     dummyresData.push(obj);
    //             //   }
    //             // }
    //             // setDummytimelineData((prev)=>dummyresData)
    //         })
    //         .catch((err) => {
    //             console.log(
    //                 "error with get hour statistic inside today vehicles-> ",
    //                 err
    //             );
    //             request_updateTimelineData_safe = true;
    //         });
    // }
    // function updateBalance() {
    //     // console.log(request_updateTimelineData_safe);
    //     if (request_updateTimelineData_safe === false) {
    //         return;
    //     } else {
    //         request_updateTimelineData_safe = false;
    //     }
    //     axios.get(`/v1/balance?token=${token}`).then((res) => {
    //         let data = res.data.flat();
    //         data = data.sort((a, b) => {
    //             return (
    //                 new Date(b["date"]).getTime() -
    //                 new Date(a["date"]).getTime()
    //             );
    //         });
    //         let TsinberiDataSum = [];
    //         let ShikmimDataSum = [];
    //         let KursiDataSum = [];

    //         data.map((da, k) => {
    //             if (da.deviceId === "600a0c2a69e8a8fa") {
    //                 return TsinberiDataSum.push(da.sum);
    //             } else if (da.deviceId === "600a0c2a69e8508a") {
    //                 return ShikmimDataSum.push(da.sum);
    //             } else if (da.deviceId === "600a0c2a69e811c8") {
    //                 return KursiDataSum.push(da.sum);
    //             }
    //         });
    //         // console.log(TsinberiDataSum,"TsinberiDataSumTsinberiDataSum")
    //         // console.log(ShikmimDataSum,"ShikmimDataSumShikmimDataSum")

    //         // console.log(data,"balance sort data")
    //         let sum = data[0]["sum"];
    //         setTsinberiSum(TsinberiDataSum[0]);
    //         setShikmimSum(ShikmimDataSum[0]);
    //         setKursiSum(KursiDataSum[0]);
    //         // console.log(TsinberiDataSum[0],ShikmimDataSum[0],"show both")
    //         if (tsinberiSum > 0) {
    //             setLoadingBalance(false);
    //         }
    //         if (kursiSum > 0) {
    //             setLoadingBalance(false);
    //         }
    //         // console.log(data,"show the balance data++++")
    //         // console.log(sum,"show the sum coorectly")
    //         // console.log("finished balance");
    //         request_updateTimelineData_safe = true;
    //         setSum((prev) => sum);
    //     });
    // }

    // console.log(compareSum, "show the compare sum ");
    // console.log(DummytimelineData, "show the DummytimelineData ");
    // console.log(timelineDataTsinberi, "show the timelineDataTsinberi ");
    // console.log(timelineDataShikmim, "show the timelineDataShikmim ");
    // let tsinberiCurrentCalculate=timelineDataTsinberi.reduce((a,b)=>{
    //   return a+=b.entering-b.leaving
    // },0)
    // let shikmimCurrentCalculate=timelineDataShikmim.reduce((a,b)=>{
    //   return a+=b.entering-b.leaving
    // },0)
    // console.log(tsinberiCurrentCalculate,"tsinberiCurrentCalculate")
    // useEffect(()=>{
    //     if (request_updateTimelineData_safe) {
    //         updateTimeBasedData();            
    //     }
    // },[deviceName])
    useEffect(() => {
        // updateTimelineData();
        // console.log(request_updateTimelineData_safe,"safe");
        // updateTimeBasedData()
        refreshHourlyHistory();
        refreshHourlyLive();
        refreshOccupancy();
        getDeviceNames();
        // updateBalance();
        // updateTimelineData();
        // setTimeout(() => {
        //   testDataTimeLine();
        // }, 5000);

        return () => { };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [request_updateTimelineData_safe]);

    useEffect(() => {
        // Prefer cached hourly series (same poll as strip/map); refetch only if empty.
        if (hourlyByLocation[lineDeviceName]?.length) {
            setLineDataByDuration(hourlyByLocation[lineDeviceName]);
        } else {
            refreshHourlyLive();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [lineDeviceName]);

    // Same-render sync so the line chart animates the new lot, not one frame of the old series.
    const lineChartData =
        hourlyByLocation[lineDeviceName]?.length > 0
            ? hourlyByLocation[lineDeviceName]
            : lineDataByDuration;

    useEffect(() => {
        updateTimeBasedDonutData();
    }, [donutDeviceName]);

    useEffect(() => {
        setCurrentEntryDevices(deviceMap.get(deviceName).filter(d => entryDevices.includes(d)));
        setCurrentExitDevices(deviceMap.get(deviceName).filter(d => exitDevices.includes(d)));
    }, [deviceName]);

    useEffect(() => {
        if (loader) {
            setLoader(false);
        }
    }, [timelineDataTsinberi, dataByDuration]);

    useEffect(() => {
        if (dataDuration !== "1D") {
            // updateTimeBasedData();
            updateTimeBasedDonutData();
        }
    }, [dataDuration, deviceName])

    const pollLiveRef = useRef(() => {});
    const pollHistoryRef = useRef(() => {});
    pollLiveRef.current = () => {
        refreshHourlyLive();
        refreshOccupancy();
    };
    pollHistoryRef.current = refreshHourlyHistory;

    useEffect(() => {
        const pollLive = () => pollLiveRef.current();
        const pollHistory = () => pollHistoryRef.current();
        const liveId = window.setInterval(pollLive, 10000);
        const historyId = window.setInterval(pollHistory, 60000);
        const onVisible = () => {
            if (document.visibilityState === "visible") {
                pollLive();
                pollHistory();
            }
        };
        document.addEventListener("visibilitychange", onVisible);
        window.addEventListener("focus", pollLive);
        return () => {
            window.clearInterval(liveId);
            window.clearInterval(historyId);
            document.removeEventListener("visibilitychange", onVisible);
            window.removeEventListener("focus", pollLive);
        };
    }, []);
    let empArray = [1, 2, 3];
    const durationButtonsName = ["1D", "5D", "1M", "6M", "1Y"];

    const totalParkingSpaces = [124, 132, 102, 140, 100, 70, 70];

    const nplKpis = useMemo(
        () => computeNplKpis(hourlyByLocation, DeviceNames),
        // DeviceNames is rebuilt each render from config; hourly series is the real input.
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [hourlyByLocation]
    );



    // console.log(compareSum, "compareSum==compareSum");
    if (loadingChart) {
        return (
            <>
                {/* <div className="flex w-full gap-2 h-[100%]">
                    <div
                        className="flex flex-col gap-2"
                        style={{ width: "50%" }}
                    >
                        <div className="bg-gray-300  w-full px-4 h-[50%] rounded-md overflow-hidden transition-all">
                            <div className="w-full h-full opacity-50 transform -translate-x-full bg-gradient-to-r from-transparent via-white to-transparent animate-slide"></div>
                        </div>
                        <div className="bg-gray-300  w-full px-4 h-[50%] rounded-md overflow-hidden transition-all">
                            <div className="w-full h-full opacity-50 transform -translate-x-full bg-gradient-to-r from-transparent via-white to-transparent animate-slide"></div>
                        </div>
                        <div className="bg-gray-300  w-[200%] px-4 h-[50%] rounded-md overflow-hidden transition-all">
                            <div className="w-full h-full opacity-50 transform -translate-x-full bg-gradient-to-r from-transparent via-white to-transparent animate-slide"></div>
                        </div>
                    </div>
                    <div
                        className="flex flex-col gap-2"
                        style={{ width: "50%" }}
                    >
                        <div className="flex justify-center h-[33.33%] gap-2">
                            <div className="bg-gray-300  w-[15%] px-4  rounded-md overflow-hidden transition-all">
                                <div className="w-full h-full opacity-50 transform -translate-x-full bg-gradient-to-r from-transparent via-white to-transparent animate-slide"></div>
                            </div>
                            <div className="bg-gray-300  w-[15%] px-4  rounded-md overflow-hidden transition-all">
                                <div className="w-full h-full opacity-50 transform -translate-x-full bg-gradient-to-r from-transparent via-white to-transparent animate-slide"></div>
                            </div>
                            <div className="bg-gray-300  w-[15%] px-4  rounded-md overflow-hidden transition-all">
                                <div className="w-full h-full opacity-50 transform -translate-x-full bg-gradient-to-r from-transparent via-white to-transparent animate-slide"></div>
                            </div>
                            <div className="bg-gray-300  w-[50%] px-4  rounded-md overflow-hidden transition-all">
                                <div className="w-full h-full opacity-50 transform -translate-x-full bg-gradient-to-r from-transparent via-white to-transparent animate-slide"></div>
                            </div>
                        </div>
                        <div className="flex justify-center h-[32%]">
                            <div className="bg-gray-300  w-full px-4 rounded-md overflow-hidden transition-all">
                                <div className="w-full h-full opacity-50 transform -translate-x-full bg-gradient-to-r from-transparent via-white to-transparent animate-slide"></div>
                            </div>
                        </div>

                    </div>
                </div> */}
                <div className="flex flex-col lg:flex-row lg:flex-wrap">
                    <div className="w-full mb-4 lg:mb-0">
                        <div className="p-1"><Skeleton className="h-96 w-full" /></div>
                    </div>

                    <div className="w-full lg:w-1/3 mb-4 lg:mb-0">
                        <div className="p-1 text-center"><Skeleton className="h-96 w-full" /></div>
                    </div>

                    <div className="w-full lg:w-1/3 mb-4 lg:mb-0">
                        <div className="p-1"><Skeleton className="h-96 w-full" /></div>
                    </div>

                    <div className="w-full lg:w-1/3">
                        <div className="p-1"><Skeleton className="h-96 w-full" /></div>
                    </div>
                </div>
            </>
        );
    }
    // return (
    //   <div
    //     className="flex flex-row justify-evenly"
    //     style={{ justifyContent: "end" }}
    //   >
    //     <YsbMainMap
    //       areas={config.areas[0]}
    //       // token={auth.token}
    //       mapConfig={config.map}
    //       colors={colors}
    //       shape="CIRCLES"
    //       // onClickHandler={clickEventHandler}
    //       buttonDesc="לצפייה בהכל לחץ כאן"
    //       // onAllClickHandler={clickEventAllHandler}
    //     />
    //     <div className="flex flex-col h-full w-4/12 justify-around px-2 chart-section">
    //       {DeviceNames.length > 0 &&
    //         DeviceNames.map(
    //           (value, index) => (
    //             <div
    //               key={deviceKeys.at(index)}
    //               className={`text-center flex flex-col mb-2  rounded-xl  bg-slate-50 p-3 `}
    //               style={{
    //                 border: "1.5px solid black",
    //                 // marginBottom: `${index === 0 ? "1rem" : "unset"}`,
    //               }}
    //             >
    //               <div className=" text-center flex w-full h-full flex-col justify-items-center justify-center chart-card-block">
    //                 {/* <div className=" font-bold ">
    //                   {textChartDescription[index]}
    //                 </div> */}
    //                 <div
    //                   className="flex flex-row items-center justify-end"
    //                   key={index}
    //                 >
    //                   <div
    //                     className="w-100 rounded-lg chart-width"
    //                     // key={deviceKeys.at(index) + "1"}
    //                   >
    //                     <h1
    //                       className="text-center"
    //                       style={{
    //                         fontSize: "1.5rem",
    //                         textAlign: "center",
    //                         marginLeft: "89px",
    //                         fontWeight: "600",
    //                       }}
    //                     >
    //                       {DeviceNames[index]}
    //                     </h1>
    //                     {/* <div>
    //                       <SvgComponent
    //                         key={deviceKeys.at(index) + index}
    //                         description={[textDescription[index]]}
    //                         svgColor={svgColors[index]}
    //                         textColor={colorTexts[index]}
    //                       />
    //                     </div> */}
    //                     <div>
    //                       {console.log(timelineData, "timelineProp")}
    //                       {console.log(stateData[index],deviceKeys.at(index), "proop")}
    //                       <LineChartComponent
    //                         key={deviceKeys.at(index) + index + index}
    //                         index={index}
    //                         // device={deviceKeys.at(index)}
    //                         device={deviceKeys.at(index)}
    //                         data={stateData[index]}
    //                         colorGraph={colors}
    //                         colorText={colorTexts}
    //                         textDescription={textChartDescription[index]}
    //                         isCustomTooltip={true}
    //                       />
    //                     </div>
    //                   </div>
    //                   {/* {types.length > 0 && (
    //               // hourly component
    //                 )} */}
    //                   {/* //components  */}
    //                   <div className="h-half 2xl:w-4/12 xl:w-4/12 lg:w-4/12 md:w-4/12 sm:w-4/12 mt-2 bg-bottom bg-slate-300 bg-blue bg-no-repeat bg-blend-screen  rounded-xl justify-items-center  text-indigo-500  justify-center items-center text-center font-bold text-xl ">
    //                     <div className="align-text-top">תפוסה נוכחית</div>
    //                     <div
    //                       className=" flex flex-col bg-transparent rounded-3xl  items-center "
    //                       style={{
    //                         paddingTop: "2.5rem",
    //                         paddingBottom: "2.5rem",
    //                       }}
    //                     >
    //                       <div className="text-white  flex text-center bg-blue-600 rounded-full p-4  ">
    //                         <div className="text-center flex">
    //                           {sumstateData[index]}
    //                         </div>
    //                       </div>
    //                       {/* <div className="text-white  flex text-center bg-blue-600 rounded-full p-4 flex-col ">
    //                         <p className="text-center" >Total occupancy</p>
    //                         <div className="text-center flex justify-content-center">{totaloccupancy+sum}</div>
    //                       </div> */}
    //                     </div>
    //                   </div>
    //                 </div>
    //               </div>
    //             </div>
    //           ),
    //           [deviceKeys]
    //         )}
    //     </div>
    //     {/* <div className="h-full w-1/5 mt-2 bg-bottom bg-slate-300 bg-blue bg-no-repeat bg-blend-screen  rounded-xl justify-items-center  text-indigo-500  justify-center items-center text-center font-bold text-xl ">
    //       <div className="align-text-top">Occupancy</div>
    //       <div className="py-32 flex flex-col bg-transparent rounded-3xl  items-center ">
    //         <div className="text-white  flex text-center bg-blue-600 rounded-full p-4  ">
    //           <div className="text-center flex">{compareSum}</div>
    //         </div>
    //       </div>
    //     </div> */}
    //     {/* <div className=" bg-blue w-full bg-no-repeat"></div> */}
    //   </div>
    // );
    // console.log(stateData[0],"statDaat");
    // console.log(deviceName,"devNam");

    return (
        // <Grid className="grid grid-cols-1 lg:grid-cols-[70%_30%] gap-4 w-full h-[calc(100vh-117px)]">
        //     <div className="bg-gray-300 p-4 rounded-l-xl shadow-[0px_-3px_9px_black] lg:shadow-[-3px_0px_9px_black]">
        //         {/* <button onClick={()=>setLoader(!loader)} >Load</button> */}
        //         {/* Location Buttons */}
        //         {/* <Button>Click me</Button> */}
        //         <div style={{ scrollbarWidth: "none" }} className="flex p-1 space-x-4 mb-4 overflow-x-auto whitespace-nowrap">
        //             {DeviceNames.map(locationName => (<button onClick={() => { setDeviceName(locationName); setLoader(true) }} style={{ boxShadow: `0px 0px 3px ${locationName === deviceName ? "0.3px black inset" : "1px black"}` }} className={`px-4 py-2 bg-${locationName === deviceName ? 'grey-500 text-black':'blue-500 text-white'} rounded`} >{locationName.replace("_", " ")}</button>))}
        //         </div>

        //         {/* Tabs */}
        //         <div style={{ scrollbarWidth: "none" }} className="flex space-x-4 mb-4 overflow-x-auto whitespace-nowrap">
        //             {durationButtonsName.map(n => <button onClick={() => { setDataDuration(n); setLoader(true) }} className={`px-3 py-1 text-gray-700 rounded-lg ${dataDuration === n ? 'border-b border-blue-500 bg-grey' : 'border-b-2 border-blue-500 bg-white'} hover:border-blue-500 focus:outline-none`}>{n}</button>)}
        //         </div>

        //         <div className="flex-grow p-3 border-3 border-solid border-[#bcc3e1] shadow-[0px_0px_9px_black] bg-white rounded-xl mb-4">
        //             <GoogleAreaChart data={dataDuration === durationButtonsName[0] ? stateData[0] : dataByDuration} hour={dataDuration === durationButtonsName[0]} loader={loader} dataDuration={dataDuration} locationName={deviceName} name={DeviceNames[0]} />
        //         </div>

        //         {/* Compare to Section */}
        //         {/* <div className="mt-auto">
        //             <h3 className="text-lg font-bold mb-2">Compare to</h3>
        //             <div className="flex space-x-4 mb-4 overflow-x-auto whitespace-nowrap">
        //                 {DeviceNames.map(locationName => (<button className="px-4 py-2 bg-blue-500 text-white rounded">{locationName}</button>))}
        //             </div>
        //         </div> */}
        //     </div>
        //     <div className="bg-gray-300 p-4 rounded-r-xl shadow-[0px_3px_9px_black] lg:shadow-[3px_0px_9px_black]"><h2 className="text-3xl text-center font-normal mb-6 lg:mb-9 2xl:my-9 font-[Roboto,Arial,sans-serif]">Location Vacancy Values</h2>
        //         <Grid className="grid grid-cols gap-3 2xl:gap-1 w-full lg:h-[calc(100vh-270px)] lg:grid-cols-2">
        //             {vacancyValue.map((value, i) => (

        //                 <div className="flex flex-col border-3 border-solid border-grey shadow-[0px_0px_9px_black] lg:shadow-[0px_0px_6px_black] 2xl:shadow-[0px_0px_9px_black] gap-6 lg:gap-2 2xl:gap-1 p-3 bg-white rounded-xl" >
        //                     <GoogleGaugeChart data={[["Label", "Value"], ["", {v:Number.isInteger(value)?(totalParkingSpaces[i]-value)*100/totalParkingSpaces[i]:100,f:Number.isInteger(value)?`${ Math.floor((totalParkingSpaces[i]-value)*100/totalParkingSpaces[i])}%`:"100%"}] ]} max={totalParkingSpaces[i]} />
        //                     <div className="text-xs text-center lg:text-sm 2xl:text-xl" >Free Parkings- {Number.isInteger(value)? value: 0}</div>
        //                     {/* <div style={{textShadow:"0px 3px 3px"}} className={ value === 'מלא' ? "text-6xl text-center text-red-800 lg:text-4xl 2xl:text-7xl": "text-6xl text-center text-emerald-600 lg:text-4xl 2xl:text-7xl"}>
        //                         <h1>{value}</h1>
        //                     </div> */}
                           
        //                     <hr></hr>
        //                     <div className="text-xl text-center 2xl:text-xl" >{DeviceNames[i].replace("_", " ")}</div>
        //                     {/* <div style={{textShadow:"0px 2px 2px"}} className="text-2xl text-center text-sky-900 2xl:text-4xl">
        //                         <h1>{totalParkingSpaces[i]}</h1>
        //                     </div>  */}
        //                 </div>
        //             ))}
        //             {/* <div className="bg-white rounded-xl" >

        //             </div>
        //             <div className="bg-white rounded-xl" >

        //             </div>
        //             <div className="bg-white rounded-xl" >

        //             </div> */}
        //         </Grid>
        //     </div>
        // </Grid>
        <>
            {/* <Component></Component> */}
                    {/* <Component/> */}
            {/* <div class="grid grid-cols-3 gap-4">
                <div class="bg-slate-400 grid grid-cols-subgrid gap-4 col-span-3">
                    <div class="bg-slate-400">01

                    <Component/>
                    </div>
                </div>
                <div class="bg-slate-400">02</div>
                <div class="bg-slate-400">03</div>
                <div class="bg-slate-400">04</div>
            </div> */}
            {/* <RadialChart total={totalParkingSpaces[0]} value={vacancyValue[0]} /> */}
            {/* <DatePickerDemo/> */}
            <NationalParkKpiCards
                todayVisitors={nplKpis.todayVisitors}
                rushHour={nplKpis.rushHour}
                leadingLocation={nplKpis.leadingLocation}
                lastWeekVisitors={nplKpis.lastWeekVisitors}
                weeklyTrend={nplKpis.weeklyTrend}
            />
            <div className="flex flex-col lg:flex-row lg:flex-wrap">
                <NationalParkOccupancyStrip
                    totalParkingSpaces={totalParkingSpaces}
                    vacancyValues={vacancyValue}
                    deviceNames={DeviceNames}
                />

                <div className="w-full mb-4 p-1">
                    <NationalParkSiteMap
                        config={config}
                        deviceNames={DeviceNames}
                        totalParkingSpaces={totalParkingSpaces}
                        vacancyValues={vacancyValue}
                        hourlyByLocation={hourlyByLocation}
                    />
                </div>

                <div className="flex flex-col lg:flex-row w-full space-y-4 lg:space-y-0 lg:space-x-4 mb-4">
                    <div className="w-full lg:w-1/2 min-w-0">
                        <div className="p-1 h-full"><NationalParkBarChart deviceNames={DeviceNames} dataByDuration={dataByDuration} updateTimeBasedData={updateTimeBasedData} /></div>
                    </div>
                    <div className="w-full lg:w-1/2 min-w-0 overflow-x-auto">
                        <div className="p-1 h-full"><NationalParkHeatmapChart deviceNames={DeviceNames} dataByDuration={dataByDuration} /></div>
                    </div>
                </div>
                
                <div className="w-full lg:w-1/2 mb-4 lg:mb-0">
                    <div className="p-1 text-center"><NationalParkShadLineChart data={lineChartData} deviceNames={DeviceNames} lineDeviceName={lineDeviceName} setLineDeviceName={setLineDeviceName} /></div>
                </div>
                
                <div className="w-full lg:w-1/2">
                    <div className="p-1"><NationalParkDonutChart data={donutDataByDuration} deviceNames={DeviceNames} donutDeviceName={donutDeviceName} setDonutDeviceName={setDonutDeviceName}/></div>
                </div>
            </div>


        </>
    );
};

export default NationalParkCombinedComponents;
